import { hotelStatusesWithCustomCharge } from 'main/hotelStatuses'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'

import { useManagePaymentPermissions } from '../../../hooks/useManagePaymentPermissions'
import { formatPrice } from '../../../utils/common'
import AddCustomChargeDialog from '../AddCustomChargeDialog'
import styles from './Balance.module.scss'

const Balance = ({
  activeBalance,
  balance = 0,
  handleSendEmailClick,
  isInternalAdmin
}) => {
  const isInitialPaymentMade = useSelector(s => s.hotelDetails.isPreOnboardingCompleted)
  const isSetupCompleted = useSelector(s => s.hotelDetails.isSetupCompleted)
  const status = useSelector(s => s.hotelDetails.status)
  const { canManagePaymentStatuses } = useManagePaymentPermissions()
  const [showAddCustomChargeDialog, setShowAddCustomChargeDialog] = useState(false)

  return (
    <>
      <div
        className={[styles.container, isInternalAdmin ? styles.adminContainer : ''].join(
          ' '
        )}
      >
        <ReactTooltip className="balance" />
        <div className={styles.balanceBox}>
          <div className={styles.label}>current balance</div>
          <div className={styles.balanceAmount}>
            {formatPrice(balance)} {canManagePaymentStatuses ? '' : 'USD'}
          </div>
        </div>
        <div className={styles.ctaBox}>
          {isInternalAdmin ? (
            <Link to="/billing/payment/check/">
              <button>Add payment</button>
            </Link>
          ) : (
            <>
              {!isSetupCompleted && !isInitialPaymentMade && (
                <button
                  className={styles.disabledButton}
                  data-tip="Please complete the onboarding process to add payment"
                >
                  Pay now
                </button>
              )}
              {isSetupCompleted && !isInitialPaymentMade && (
                <Link to="/hotel-setup">
                  <button>Pay now</button>
                </Link>
              )}
              {isInitialPaymentMade && (
                <Link to="/billing/payment/check/">
                  <button>Pay now</button>
                </Link>
              )}
            </>
          )}

          {canManagePaymentStatuses &&
            isInitialPaymentMade &&
            hotelStatusesWithCustomCharge.includes(status) && (
              <button onClick={() => setShowAddCustomChargeDialog(true)}>
                Add invoice
              </button>
            )}

          {isInternalAdmin && (
            <button
              data-tip={
                activeBalance > 0 ? '' : "Can't send for zero or negative balance"
              }
              onClick={activeBalance > 0 ? handleSendEmailClick : () => false}
              className={activeBalance > 0 ? '' : styles.disabledButton}
            >
              Send invoice
            </button>
          )}
        </div>
      </div>
      {showAddCustomChargeDialog && (
        <AddCustomChargeDialog
          onClose={() => setShowAddCustomChargeDialog(false)}
          isForChargeback={false}
        />
      )}
    </>
  )
}

export default Balance
